import { NavigationUser } from './Props';

export const isExternalUser = (user: NavigationUser) =>
  user.role === 'VENDOR' ||
  user.role === 'VENDOR_STAFF' ||
  user.role === 'VENDOR_OPERATIONS' ||
  user.role === 'INFLUENCER';
